export const SET_PENDING = "state/repair-parts/SET_PENDING";
export const SET_TOUCHED = "state/repair-parts/SET_TOUCHED";
export const SET_REPAIR_PARTS = "state/repair-parts/SET_REPAIR_PARTS";
export const FORGET_REPAIR_PARTS = "state/repair-parts/FORGET_REPAIR_PARTS";
